import React, { useEffect, useState } from 'react';
import PatientPortalRouter from '../PatientPortalRouter/PatientPortalRouter';
import { useContext } from 'react';
import { UserEngagementContext } from '../../../utils/userEngagementContext';
import { SourceContext } from '../../../utils/sourceContext';
import InactivityPopUp from '../InactivityPopUp/InactivityPopUp';
import usePopUp from '../../../hooks/usePopUp';

import styles from './footer.module.css';
import logo from '../../../assets/logo.png';
import PhoneIcon from '@mui/icons-material/Phone';
import MailIcon from '@mui/icons-material/Mail';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import { Link } from 'react-router-dom';

function Footer() {

    const [isInactivityPopUpOpen, openInactivityPopUp, closeInactivityPopUp] = usePopUp(false);
    const [patientRouterOpen, setPatientRouterOpen] = useState(false);
    const { latestLeadTimestamp, hasTidioInteracted } = useContext(UserEngagementContext);
    const { source } = useContext(SourceContext);

    
    // Derived state on each render (this ensures that the component accesses the latest values)
    const shouldBlockBySource = source === "email";
    const shouldBlockByTidio = hasTidioInteracted;

    // Show inactivity popUp to the user only once per 3 days from last successful response
    const shouldBlockByRecentLead = (() => {
        const todaysDate = localStorage.getItem("todaysDate");
        if (!todaysDate || latestLeadTimestamp === null) return false;

        const responseDate = new Date(latestLeadTimestamp);
        const todayDate = new Date(todaysDate);
        const differenceInDays = (todayDate - responseDate) / (1000 * 3600 * 24);

        return differenceInDays <= 3;
    })();

    const shouldShowInactivity = !shouldBlockBySource && !shouldBlockByTidio && !shouldBlockByRecentLead;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {

        if (!shouldShowInactivity) return;

        const timeout = setTimeout(() => {
            if (isInactivityPopUpOpen) return;
            openInactivityPopUp();
        }, 180000); // 3 minutes

        return () => clearTimeout(timeout);

    }, [shouldShowInactivity]);

    return (
       <>   
        <PatientPortalRouter open={patientRouterOpen} onClose={() => setPatientRouterOpen(false)} />
        <div className={styles.footer}>

            <div className={styles.mainContainer}>

                <img className={styles.logo} src={logo} alt='wait' onClick={() => window.scrollTo(0, 0)} />

                <div className={`${styles.linksContainer} ${styles.socialsContainer}`}>
                    <div className={styles.socialContainer}>
                        <div className={styles.socialCircle}>
                            <PhoneIcon className={styles.socialIcon} />
                        </div>
                        <a href='tel:8445703201'> 844.570.3201</a>
                    </div>
                    <div className={styles.socialContainer}>
                        <div className={styles.socialCircle}>
                            <ChatBubbleIcon className={styles.socialIcon} />
                        </div>
                        <a href='sms:14407974172'> 440.797.4172</a>
                    </div>
                    <div className={styles.socialContainer}>
                        <div className={styles.socialCircle}>
                            <MailIcon className={styles.socialIcon} />
                        </div>
                        <a href='mailto:social@tb2.health'> social@tb2.health</a>
                    </div>
                </div>

                <div className={styles.linksContainer}>
                    <Link to='/programs' className={styles.link}><p>Programs</p></Link>
                    <Link to='/about' className={styles.link}><p>About Us</p></Link>
                    <Link to='/contact' className={styles.link}><p>Contact Us</p></Link>
                </div>

                <div className={styles.linksContainer}>
                    <Link to='/knowledge-center' className={styles.link}><p>Knowledge Center</p></Link>
                    <Link to='/articles' className={styles.link}><p>Articles</p></Link>
                    <Link to='/success-stories' className={styles.link}><p>Success Stories</p></Link>
                </div>

                <div className={styles.linksContainer}>
                    <button
                        onClick={() => {process.env.REACT_APP_PATIENT_PORTAL_ENABLED === 'true' ? setPatientRouterOpen(true) : window.open('https://patient.tb2.health', '_blank', 'noopener,noreferrer')}}
                        className={styles.link}
                        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, font: 'inherit', textAlign: 'left' }}
                    >
                        <p>Patient Portal</p>
                    </button>
                    <Link to='/billing' className={styles.link}>
                        <p>Billing</p>
                    </Link>
                </div>

            </div>

            <div className={styles.legitscriptContainer}>
                <a href="https://www.legitscript.com/websites/?checker_keywords=tb2.health" target="_blank" title="Verify LegitScript Approval for www.tb2.health">
                <   img src="https://static.legitscript.com/seals/18502077.png" alt="Verify Approval for www.tb2.health" className={styles.legitscriptLogo}/>
                </a>
            </div>

            <div className={styles.copyrightContainer}>
                <p className={styles.copyrightText}>2025 Pillars for Health. All Rights Reserved</p>
                <div className={styles.pipe}>|</div>
                <p className={styles.addressText}>645 Howe Ave #1026, Cuyahoga Falls, OH 44221, Summit County, OH</p>
            </div>
            <div className={styles.legalContainer}>
                <Link to='/terms' className={styles.link} target="_blank" rel="noopener noreferrer"><p>Terms and Conditions</p></Link>
                <div className={styles.pipe}>|</div>
                <Link to='/privacy' className={styles.link} target="_blank" rel="noopener noreferrer"><p>Privacy Policy</p></Link>
                <div className={styles.pipe}>|</div>
                <p className={styles.link} onClick={() => window.silktideCookieBannerManager.openPreferencesModal()}>Cookie Preferences</p>
                <div className={styles.pipe}>|</div>
                <Link to='/cookie-policy' className={styles.link} target="_blank" rel="noopener noreferrer"><p>Cookie Policy</p></Link>
                <div className={styles.pipe}>|</div>
                <a
                    href="#"
                    className={styles.link}
                    onClick={(e) => {
                        e.preventDefault();
                        window.openSiennaWidget?.();
                    }}
                    >
                    Accessibility Options
                </a>
            </div>
            {/* <div className={styles.addressContainer}>
                <p className={styles.addressText}>645 Howe Ave #1026, Cuyahoga Falls, OH 44221, Summit County, OH</p>
            </div> */}
            
        </div>
        <InactivityPopUp isOpen={isInactivityPopUpOpen} onClose={closeInactivityPopUp} />
       </>  
    );
}

export default Footer;
